import WebFont from 'webfontloader';
import { useFonts } from '@/composables/api/useFonts';

const fontsApi = useFonts();
const systemFonts = [
    'Arial',
    'Verdana',
    'Tahoma',
    'Trebuchet MS',
    'Times New Roman',
    'Georgia',
    'Garamond',
    'Courier New',
    'Brush Script MT',
    'Impact'
];

export async function loadFonts(apiKey: string): Promise<string[]> {
    let fonts: string[] = [...systemFonts];
    try {
        const { data, error } = await fontsApi.fetchGoogleFonts(apiKey);
        if (error.value) {
            console.error('Error fetching Google Fonts');
            return fonts.sort();
        }
        if (data.value) {
            const googleFonts: string[] = data.value.items.slice(0, 100).map((font: { family: string }) => font.family);
            fonts = [...new Set([...systemFonts, ...googleFonts])];
            WebFont.load({
                google: {
                    families: googleFonts
                }
            });
        }
    } catch (error) {
        console.error('Error loading fonts:', error);
    }

    return fonts.sort();
}
